// GENERATED by scripts/generate-screen-manifest.mjs (prebuild) — do not edit.
export const SCREEN_MANIFEST = {
  "/hero/hero-card-sos.jpg": false,
  "/hero/hero-card-monitoring.jpg": false,
  "/screens/family-circle.jpg": false,
  "/screens/im-safe.jpg": false,
  "/screens/safety-zones.jpg": false,
  "/aditi-safe-zone.jpg": false,
  "/papa-live-tracking.jpg": false
};
